import { render, staticRenderFns } from "./RegionsSettings.vue?vue&type=template&id=9cea943e&scoped=true&"
import script from "./RegionsSettings.vue?vue&type=script&lang=js&"
export * from "./RegionsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cea943e",
  null
  
)

export default component.exports